import { render, staticRenderFns } from "./ProductoTransferirStockModal.vue?vue&type=template&id=d856449c&scoped=true&"
import script from "./ProductoTransferirStockModal.vue?vue&type=script&lang=js&"
export * from "./ProductoTransferirStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d856449c",
  null
  
)

export default component.exports